const query = `mutation Checkout(
    $items: [ItemInput!],
    $paymentToken: String,
    $customer: CustomerInput,
    $shipping: AddressInput,
    $billing: AddressInput,
    $coupons: [CouponInput!],
    $customFields: TransactionCustomFields,
    $paymentInstrument: PaymentInstrumentInput
  ) {
    checkout(
      items: $items,
      coupons: $coupons,
      customer: $customer,
      shipping: $shipping,
      billing: $billing,
      paymentToken: $paymentToken,
      paymentInstrument: $paymentInstrument,
      customFields: $customFields
    ) {
      transaction {
        id,
        amount,
        status,
        result,
        paymentInstrument {
          method,
          paymentCardId
        }
      },
      customer {
        email,
        id
      }
    }
  }`;
export default query;
//# sourceMappingURL=query.js.map